module.exports = __webpack_public_path__ + "static/media/gallery (7).cca7ffa2.jpg";